<common-validation-card *ngIf="errorMessage" [messages]="[errorMessage]" [showX]="true" cardClass="card border-primary card-h50px"></common-validation-card>
<div *ngIf="errorMessage" class="bb-light my-3"></div>
<div class="mb-2" *ngIf="paymentMethodCards">
  <common-checkbox-cards [checkboxCards]="paymentMethodCards" [singleSelect]="true" (checkboxCardsChange)="paymentMethodOnChange($event)"></common-checkbox-cards>
</div>

<common-payment-element
  *ngIf="newPaymentMethod"
  [showButton]="showCreateButton"
  (errorMessage)="errorMessage = $event"
  [paymentCompletionPage]="paymentCompletionPage"
></common-payment-element>

<div class="d-flex justify-content-center" [class.neg-mt-25]="!showCreateButton" [class.mt-25]="showCreateButton">
  <img class="img-fluid" src="https://company.rubbl.com/pubweb/marketplace/images/logos/powered-by-stripe.jpg" alt="Powered by Stripe" />
</div>
